import {apiRedux} from "../reducers/apiRedux";
import {apiUrls} from "../../constants/appUrls";
import {creditLineTypes} from "../../routes/SAAS/AdSystems/AdSystemTenancyGoogleCreditLine";
import {cookieOptions, getCookie, setCookie} from "../../utils/api";
import {authConstants} from "../../constants/authConstants";

const TenancyApi = apiRedux.injectEndpoints({
  endpoints: (build) => ({
    getTenancyList: build.query({
      query: () => ({
        url: apiUrls.tenancyList
      }),
      keepUnusedDataFor: 4,
      providesTags: (result) => [{type: 'tenancy_list', id: result.id}],

      transformResponse: (response) => {
        const currentTenantCookie = getCookie(authConstants.tenant);
        const currentTenantResponse =  response?.[0]?.value;
        !currentTenantCookie && setCookie(authConstants.tenant, currentTenantResponse, cookieOptions);

        return response
      }
    }),

    createTenancy: build.mutation({
      query: (data) => ({
        url: apiUrls.createTenancy,
        method: 'POST',
        body: data,
      }),

    }),

    updateTenancy: build.mutation({
      query: (data) => ({
        url: apiUrls.updateTenancyById.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
    }),

    getTenancyById: build.query({
      query: (id) => ({
        url: apiUrls.tenancyById.formatURL({id})
      }),
      keepUnusedDataFor: 2,
    }),

    getTenancyLang: build.query({
      query: (id) => ({
        url: apiUrls.getTenancyLang.formatURL({id})
      }),
      keepUnusedDataFor: 2,
    }),

    saveTenancyLang: build.mutation({
      query: (data) => ({
        url: apiUrls.saveTenancyLang.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    }),

    getApiGateToken: build.query({
      query: (id) => ({
        url: apiUrls.getTenancyApiGateToken.formatURL({id})
      }),
      keepUnusedDataFor: 2,
    }),

    setApiGateToken: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyApiGateToken.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    }),

    getGoogleInfo: build.query({
      query: (id) => ({
        url: apiUrls.getTenancyGoogleCreditLine.formatURL({id})
      }),
      keepUnusedDataFor: 2,
      transformResponse: () => {
        return {
          creditLineType: creditLineTypes.Personal,
          clientTagInfo: [
            {clientTagType: "KZ", middleMCC: "321654897", billingAccount: "3216-6546-9878-6542"},
            {clientTagType: "NR KZ", middleMCC: "321654897", billingAccount: "3216-6546-9878-6542"},
            {clientTagType: "XXX", middleMCC: null, billingAccount: null},
            {clientTagType: "Asia", middleMCC: "321654897", billingAccount: "3216-6546-9878-6542"},
            {clientTagType: "Test", middleMCC: null, billingAccount: null},

          ],
          diffApi: true,
          middleMcc: "321654897",
          clientId: 321654,
          refreshToken: 123,
          clientSecret: "clientSecretGoogle",
          developerToken: "3535vdrdgv",
          loginCustomerId: "34"

        }
      }
    }),

    setGoogleInfo: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyGoogleCreditLine.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    }),

    setGoogleTagInfo: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyGoogleTag.formatURL({id: data.id}),
        method: 'POST',
        body: data.data,
      }),
      keepUnusedDataFor: 2,
    }),

    setGoogleApiInfo: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyGoogleApi.formatURL({id: data.id}),
        method: 'POST',
        body: data.data,
      }),
      keepUnusedDataFor: 2,
    }),


    getFacebookInfo: build.query({
      query: (id) => ({
        url: apiUrls.getTenancyFacebookCreditLine.formatURL({id})
      }),
      keepUnusedDataFor: 2,
      transformResponse: () => {
        return {
          creditLineType: creditLineTypes.Personal,
          appId: "string",
          middleMcc: "321654897",
          clientId: 321654,
          refreshToken: 123,
          developerToken: "3535vdrdgv",
          loginCustomerId: "34"

        }
      }
    }),

    setFacebookInfo: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyFacebookCreditLine.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    }),

    setFacebookApiInfo: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyFacebookApi.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    }),


    getTTInfo: build.query({
      query: (id) => ({
        url: apiUrls.getTenancyTikTokCreditLine.formatURL({id})
      }),
      keepUnusedDataFor: 2,
      transformResponse: () => {
        return {
          creditLineType: creditLineTypes.Personal,
          clientId: "clientIdTT",
          clientSecret: "clientSecretTT",
          accessToken: "accessTokenTT",

        }
      }
    }),

    setTiktokInfo: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyTikTokCreditLine.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    }),

    setTiktokInfoApi: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyTikTokApi.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    }),


    getYandexInfo: build.query({
      query: (id) => ({
        url: apiUrls.getTenancyYandexCreditLine.formatURL({id})
      }),
      keepUnusedDataFor: 2,
      transformResponse: () => {
        return {
          creditLineType: creditLineTypes.Personal,
          clientId: "clientId Yandex",
          clientSecret: "clientSecret Y",
          clientAccountLogin: "clientAccountLogin Y",
          accessToken: "accessToken Y",
          financeToken: "accessToken Y",

        }
      }
    }),

    setYandexInfo: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyYandexCreditLine.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    }),

    setYandexApiInfo: build.mutation({
      query: (data) => ({
        url: apiUrls.setTenancyYandexApi.formatURL({id: data.id}),
        method: 'POST',
        body: data.data,
      }),
      keepUnusedDataFor: 2,
    }),

    getTenancyMccList: build.query({
      query: (id) => ({
        url: apiUrls.getTenancyMccList.formatURL({id})
      }),
      keepUnusedDataFor: 2,
      transformResponse: () => {
        return [
          {label: "123", value: "123"},
          {label: "4645", value: "4645"},
          {label: "344et", value: "344et"},
          {label: "6867", value: "6867"},

        ]
      }
    }),

    getSAASMccList: build.query({
      query: (id) => ({
        url: apiUrls.getSAASMccList.formatURL({id})
      }),
      keepUnusedDataFor: 2,
      transformResponse: () => {
        return [
          {
            id: 1,
            legalCompanyNameRu: "name1",
            clientMccAsiaXXX: 7,
            clientMccKZNRKZ: 98,
            testsMcc: 206

          },
          {
            id: 2,
            legalCompanyNameRu: "name2",
            clientMccAsiaXXX: 4,
            clientMccKZNRKZ: 100,
            testsMcc: 200

          },
        ]
      }
    }),

    addMcc: build.mutation({
      query: (data) => ({
        url: apiUrls.addGoogleMcc.formatURL({id: data.id}),
        method: 'POST',
        body: data,
      }),
      keepUnusedDataFor: 2,
    })

  })
});

export const {useGetTenancyListQuery} = TenancyApi;
export const {useGetSAASMccListQuery} = TenancyApi;
export const {useGetTTInfoQuery} = TenancyApi;
export const {useGetYandexInfoQuery} = TenancyApi;
export const {useGetGoogleInfoQuery} = TenancyApi;
export const {useGetFacebookInfoQuery} = TenancyApi;
export const {useGetTenancyMccListQuery} = TenancyApi;
export const {useSetGoogleInfoMutation} = TenancyApi;
export const {useAddMccMutation} = TenancyApi;
export const {useSetYandexApiInfoMutation} = TenancyApi;
export const {useSetYandexInfoMutation} = TenancyApi;
export const {useSetTiktokInfoMutation} = TenancyApi;
export const {useSetTiktokInfoApiMutation} = TenancyApi;
export const {useSetFacebookInfoMutation} = TenancyApi;
export const {useSetFacebookApiInfoMutation} = TenancyApi;
export const {useSetGoogleTagInfoMutation} = TenancyApi;
export const {useSetGoogleApiInfoMutation} = TenancyApi;
export const {useGetApiGateTokenQuery} = TenancyApi;
export const {useCreateTenancyMutation} = TenancyApi;
export const {useSetApiGateTokenMutation} = TenancyApi;
export const {useUpdateTenancyMutation} = TenancyApi;
export const {useGetTenancyLangQuery} = TenancyApi;
export const {useGetTenancyByIdQuery} = TenancyApi;
export const {useSaveTenancyLangMutation} = TenancyApi;

